import { Route, Routes } from "react-router-dom";
import Home from "../pages/Home";
import About from "../pages/About";
import Admission from "../pages/Admission";
import Calendar from "../pages/Calendar";
import Contact from "../pages/Contact";
import Faculity from "../pages/Faculity";
import PrivacyPolicy from "../pages/PrivacyPolicy";
import Terms from "../pages/Terms";
import RoutesPage from "../pages/Routes";

const AppRoutes = () => {
  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/about" element={<About />} />
      <Route path="/admission" element={<Admission />} />
      <Route path="/calendar" element={<Calendar />} />
      <Route path="/contact" element={<Contact />} />
      <Route path="/faculity" element={<Faculity />} />
      <Route path="/privacy" element={<PrivacyPolicy />} />
      <Route path="/terms" element={<Terms />} />
      <Route path="/transport-routes" element={<RoutesPage />} />
    </Routes>
  );
};
export default AppRoutes;
